module.exports = __webpack_public_path__ + "img/logo_.f6248445.png";